<template>
  <div id="studio" v-show="ok">
    <div class="app-head">
      <span class="app-logo">ToLink</span>
    </div>
    <div class="app-menu">
      <div class="app-menu-name">云组态</div>
      <div class="app-menu-app"
        :style="{'background-color': appMenuIdx === 0 ? '#1a2427' : '', color: appMenuIdx === 0 ? '#409EFF' : '#eee'}"
        @click="appMenuClick(0)"
      >
        <div class="app-menu-area" v-show="appMenuIdx == 0"></div>
        已发布组态
      </div>
      <div class="app-menu-app"
        :style="{'background-color': appMenuIdx === 1 ? '#1a2427' : '', color: appMenuIdx === 1 ? '#409EFF' : '#eee'}"
        @click="appMenuClick(1)"
      >
        <div class="app-menu-area" v-show="appMenuIdx == 1"></div>
        待发布组态
      </div>
      <div class="app-menu-app"
        :style="{'background-color': appMenuIdx === 2 ? '#1a2427' : '', color: appMenuIdx === 2 ? '#409EFF' : '#eee'}"
        @click="appMenuClick(2)"
      >
        <div class="app-menu-area" v-show="appMenuIdx == 2"></div>
        我的素材库
      </div>
      <div class="app-menu-app"
        :style="{'background-color': appMenuIdx === 3 ? '#1a2427' : '', color: appMenuIdx === 3 ? '#409EFF' : '#eee'}"
        @click="appMenuClick(3)"
      >
        <div class="app-menu-area" v-show="appMenuIdx == 3"></div>
        公共素材库
      </div>
    </div>

    <mu-fade-transition>
      <div class="app-compose-head" v-if="appMenuIdx == 0">
        <input type="text" placeholder="组态名称" class="layui-input" v-model="zutaiNameSearch" @keyup.enter="searchZutai" />
        <mu-button fab small color="primary" @click="searchZutai">
          <mu-icon size="22" value="search"></mu-icon>
        </mu-button>
      </div>
    </mu-fade-transition>
    <mu-fade-transition>
      <div class="app-compose" v-if="appMenuIdx == 0 ">
        <div class="app-compose-item" v-for="(item, index) in showlist" :key="index">
          <div class="app-compose-img">
            <img v-if="viewLock !== item.id" :src="
              'https://dynalt2.lvshuimeng.com/cover/' +
              item.id +
              '.png?rand=' +
              parseInt(10 * Math.random())
            " />
            <label :for="'cover' + index">
              <mu-icon size="18" value="perm_media" color="grey50"></mu-icon>
            </label>
            <input v-show="false" type="file" :id="'cover' + index" @change="coverEdit($event, item.id)" accept=".png" />
          </div>
          <div class="app-compose-info">
            <div class="app-compose-check">
              <div class="app-compose-checkbox"></div>
            </div>
            <div class="app-compose-name">{{ item.name }}</div>
            <div class="app-compose-id">ID: {{ item.id }}</div>
          </div>
          <div class="app-compose-foot">
            <a class="app-compose-but" :style="item.release ? 'cursor:not-allowed;color:#c9c9c9' : ''" @click="releaseEvent(item, true)">发布</a>
            <a class="app-compose-but" @click="viewEvent(item.id)">运行</a>
            <a class="app-compose-but" @click="editEvent(item.id)">编辑</a>
            <a class="app-compose-but border-none">分享</a>
            <a class="app-compose-but" :style="item.release ? '' : 'cursor:not-allowed;color:#c9c9c9'" @click="releaseEvent(item, false)">下架</a>
            <a class="app-compose-but" @click="updateEvent(item)">设置</a>
            <a class="app-compose-but" @click="copyEvent(item)">复制</a>
            <a class="app-compose-but border-none" @click="deleteEvent(item.id)">
              删除
            </a>
          </div>
        </div>
      </div>
    </mu-fade-transition>

    <mu-fade-transition>
      <div class="app-compose-head" v-if="appMenuIdx == 1">
        <input type="text" placeholder="组态名称" class="layui-input" />
        <mu-button fab small color="primary">
          <mu-icon size="22" value="search"></mu-icon>
        </mu-button>
        <mu-button round color="primary" @click="createEdit()">
          创建组态
        </mu-button>
      </div>
    </mu-fade-transition>
    <mu-fade-transition>
      <div class="app-compose" v-if="appMenuIdx == 1">
        <div class="app-compose-item" v-for="(item, index) in showlist" :key="index">
          <div class="app-compose-img">
            <img v-if="viewLock !== item.id" :src="
              'https://dynalt2.lvshuimeng.com/cover/' +
              item.id +
              '.png?rand=' +
              parseInt(10 * Math.random())
            " />
            <label :for="'cover' + index">
              <mu-icon size="18" value="perm_media" color="grey50"></mu-icon>
            </label>
            <input v-show="false" type="file" :id="'cover' + index" @change="coverEdit($event, item.id)" accept=".png" />
          </div>
          <div class="app-compose-info">
            <div class="app-compose-check">
              <div class="app-compose-checkbox"></div>
            </div>
            <div class="app-compose-name">{{ item.name }}</div>
            <div class="app-compose-id">ID: {{ item.id }}</div>
          </div>
          <div class="app-compose-foot">
            <a class="app-compose-but" :style="item.release ? 'cursor:not-allowed;color:#c9c9c9' : ''" @click="releaseEvent(item, true)">发布</a>
            <a class="app-compose-but" @click="viewEvent(item.id)">运行</a>
            <a class="app-compose-but" @click="editEvent(item.id)">编辑</a>
            <a class="app-compose-but border-none">分享</a>
            <a class="app-compose-but" :style="item.release ? '' : 'cursor:not-allowed;color:#c9c9c9'" @click="releaseEvent(item, false)">下架</a>
            <a class="app-compose-but" @click="updateEvent(item)">设置</a>
            <a class="app-compose-but" @click="copyEvent(item)">复制</a>
            <a class="app-compose-but border-none" @click="deleteEvent(item.id)">
              删除
            </a>
          </div>
        </div>
      </div>
    </mu-fade-transition>

    <mu-fade-transition>
      <div class="app-material-head app-compose-head" v-if="appMenuIdx == 2">
        <div style="
          height: 50px;
          padding-left: 20px;
          line-height: 50px;
          font-size: 14px;
          font-weight: 700;
          color: #666;
        ">
          素材总数: {{ materialPrivate.length }}
        </div>
        <label for="materialUpload" class="materialUpload"> 本地素材 </label>
        <input id="materialUpload" v-show="false" type="file" @change="uploadEdit($event)" accept=".gif,.png,.jpeg,.jpg,.svg" />
      </div>
    </mu-fade-transition>
    <mu-fade-transition>
      <div class="app-material-private" v-if="appMenuIdx == 2">
        <div v-if="viewLock" style="position: relative; width: 100%; padding: 10px; overflow: hidden">
          <div class="material-item" v-for="(url, idx) in materialPrivate" :key="idx">
            <div class="img"><img :src="url" /></div>
            <div class="btn">
              <div @click="materialDelete(url)">
                <mu-icon size="20" value="delete" style="margin: 14px 0"></mu-icon>
                移除
              </div>
              <a :href="url" download="" target="_blank">
                <mu-icon size="20" value="find_in_page" style="margin: 14px 0"></mu-icon>
                查看
              </a>
            </div>
          </div>
        </div>
      </div>
    </mu-fade-transition>

    <mu-fade-transition>
      <div class="app-material-nav" v-if="appMenuIdx == 3">
        <div class="name">素材类型：</div>
        <div class="url" v-for="(item, index) in materialLabel" :key="index" :style="materialIdx == index ? 'border: 1px solid #108CEE' : ''"
          @click="materialClassClick(index)">
          {{ item }}
        </div>
      </div>
    </mu-fade-transition>
    <mu-fade-transition>
      <div class="app-material-public" v-if="appMenuIdx == 3">
        <div v-if="viewLock" style="position: relative; width: 100%; padding: 10px; overflow: hidden">
          <div class="material-item" v-for="(url, idx) in materialList" :key="idx">
            <div class="img"><img :src="url" /></div>
            <div class="btn">
              <div @click="materialSave(url)">
                <mu-icon size="20" value="open_in_browser" style="margin: 14px 0"></mu-icon>
                添加
              </div>
              <a :href="url" download="" target="_blank">
                <mu-icon size="20" value="find_in_page" style="margin: 14px 0"></mu-icon>
                查看
              </a>
            </div>
          </div>
        </div>
      </div>
    </mu-fade-transition>
  </div>
</template>

<script>
import CreateEdit from "../components/create.vue";
import UpdateEdit from "../components/update.vue";

import {
  dynalt_List,
  dynalt_Update,
  dynalt_Delete,
  dynalt_Create,
  dynalt_Material_Label,
  dynalt_Material_List,
  dynalt_Material_Save,
  dynalt_Material_Private,
  dynalt_Material_Delete,
  dynalt_Material_Upload,
  dynalt_Material_Cover,
} from "../network/dynalt.js";

import { tolink_Info } from "../network/tolink.js";

import { getUrlKey } from "../assets/option.js";

import { login } from '../api/user.js'

let lodash = require("lodash");

export default {
  mounted() {
    this.dynaltList();
    this.token = getUrlKey("token");
    this.setToken()
  },
  data() {
    return {
      token: "",
      ok: false,

      appMenuIdx: 0,
      appComposePage: 1,
      dynalt: [],
      showlist: [],

      materialIdx: 0,
      materialLabel: [],
      materialList: [],
      viewLock: false,

      materialPrivate: [],

      zutaiNameSearch: '' // 查询组态名称
    };
  },
  watch: {
    appMenuIdx() {
      switch (this.appMenuIdx) {
        case 0:
        case 1:
          this.updaeShowList();
          return;
        case 2:
          this.dynaltMaterialPrivate();
          return;
        case 3:
          this.dynaltMaterialLabel();
          break;
      }
    },
    dynalt() {
      this.updaeShowList();
    },
    materialIdx() {
      this.dynaltMaterialList(this.materialLabel[this.materialIdx]);
    },
  },
  methods: {
    async setToken() {
      if (!this.token && process.env.NODE_ENV === 'development') { // 开发模式
        const res = await login({
          username: 'ditoo',
          password: 'ditoo_password'
        })
        this.token = `Bearer ${res.return.token}`
      }
      if (this.token) {
        this.tolinkInfo(this.token)
      } else {
        this.$router.push('/board')
      }
    },
    updaeShowList() {
      this.showlist = [];
      for (let item of this.dynalt) {
        switch (this.appMenuIdx) {
          case 0:
            if (item.release) {
              this.showlist.push(item);
            }
            break;
          case 1:
            if (!item.release) {
              this.showlist.push(item);
            }
            break;
        }
      }
      return this.showlist;
    },
    searchZutai() {
      this.showlist = []
      const showlist = []
      for (let item of this.dynalt) {
        switch (this.appMenuIdx) {
          case 0:
            if (item.release) {
              showlist.push(item);
            }
            break;
          case 1:
            if (!item.release) {
              showlist.push(item);
            }
            break;
        }
      }
      showlist.forEach(item => {
        if (item.name.indexOf(this.zutaiNameSearch) !== -1) {
          this.showlist.push(item)
        }
      })
    },
    releaseEvent(item, val) {
      let msg = val ? "发布" : "下架";
      this.$confirm("确定要" + msg + "？", "提示", {}).then(({ result }) => {
        if (result) {
          let item_c = lodash.cloneDeep(item);
          item_c.release = val;
          this.dynaltUpdate(item_c);
        }
      });
    },
    appMenuClick(idx) {
      this.appMenuIdx = idx;
    },
    createEdit() {
      this.$layer.iframe({
        content: {
          content: CreateEdit,
          parent: this,
          data: {
            success: this.dynaltList,
          },
        },
        area: ["400px", "340px"],
        title: "创建组态",
        cancel: () => {},
      });
    },
    updateEvent(item) {
      this.$layer.iframe({
        content: {
          content: UpdateEdit,
          parent: this,
          data: {
            form: item,
            success: this.dynaltList,
          },
        },
        area: ["400px", "340px"],
        title: "设置组态",
        cancel: () => {},
      });
    },
    deleteEvent(id) {
      this.$confirm("确定要删除？", "提示", {}).then(({ result }) => {
        if (result) {
          this.dynaltDelete(id);
        }
      });
    },
    copyEvent(item) {
      this.$confirm("确定要复制此应用？", "提示", {}).then(({ result }) => {
        if (result) {
          let item_c = lodash.cloneDeep(item);
          item_c.name += "（复制）";
          this.dynaltCreate(item_c);
        }
      });
    },
    viewEvent(id) {
      let routeUrl = this.$router.resolve({
        path: "/board",
        query: { id },
      });
      window.open(routeUrl.href, "_blank");
    },
    editEvent(id) {
      let routeUrl = this.$router.resolve({
        path: "/edit",
        query: { id, token: this.token },
      });
      window.open(routeUrl.href, "_blank");
    },
    dynaltList() {
      this.viewLock = false;
      dynalt_List()
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.list == null) {
              res.data.return.list = [];
            }
            this.dynalt = res.data.return.list;
            this.viewLock = true;
          } else {
            this.$toast.error("获取列表失败");
          }
        })
        .catch(this.catchErr);
    },
    dynaltUpdate(data) {
      this.viewLock = false;
      dynalt_Update(data)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success(res.data.msg);
            this.dynaltList();
            this.viewLock = true;
          } else {
            this.$toast.error(res.data.msg);
          }
        })
        .catch(this.catchErr);
    },
    dynaltDelete(id) {
      this.viewLock = false;
      dynalt_Delete(id)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success(res.data.msg);
            this.dynaltList();
            this.viewLock = true;
          } else {
            this.$toast.error(res.data.msg);
          }
        })
        .catch(this.catchErr);
    },
    dynaltCreate(item) {
      this.viewLock = false;
      dynalt_Create(item)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success(res.data.msg);
            this.dynaltList();
            this.viewLock = true;
          } else {
            this.$toast.error(res.data.msg);
          }
        })
        .catch(this.catchErr);
    },

    /* - - - - - - - */

    coverEdit(event, id) {
      let fileType = event.target.files[0].name.split(".").pop().toLowerCase();

      setTimeout(() => {
        this.dynaltMaterialCover(id, fileType, event.target.files[0]);
      }, 1000);
    },
    uploadEdit(event) {
      let fileType = event.target.files[0].name.split(".").pop().toLowerCase();

      setTimeout(() => {
        this.dynaltMaterialUpload(fileType, event.target.files[0]);
      }, 1000);
    },
    materialClassClick(idx) {
      this.materialIdx = idx;
    },
    materialSave(url) {
      this.$confirm("添加到我的素材库？", "提示", {}).then(({ result }) => {
        if (result) {
          this.dynaltMaterialSave(url);
        }
      });
    },
    materialDelete(url) {
      this.$confirm("从列表中删除？", "提示", {}).then(({ result }) => {
        if (result) {
          this.dynaltMaterialDelete(url);
        }
      });
    },
    tolinkInfo(token) {
      tolink_Info(token)
        .then(res => {
          if (res.data.code == 200) {
            this.ok = true;
          } else {
            this.ok = false;
            this.$toast.error("无访问权限");
          }
        })
        .catch(this.catchErr);
    },
    dynaltMaterialLabel() {
      dynalt_Material_Label()
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.list == null) {
              res.data.return.list = [];
            }
            this.materialLabel = res.data.return.list;
            this.dynaltMaterialList(this.materialLabel[this.materialIdx]);
          }
        })
        .catch(this.catchErr);
    },
    dynaltMaterialList(label) {
      this.viewLock = false;
      dynalt_Material_List(label)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.list == null) {
              res.data.return.list = [];
            }
            this.materialList = res.data.return.list;
            this.viewLock = true;
          }
        })
        .catch(this.catchErr);
    },
    dynaltMaterialSave(url) {
      dynalt_Material_Save(url)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success("添加成功");
          } else {
            this.$toast.error("添加失败");
          }
        })
        .catch(this.catchErr);
    },
    dynaltMaterialPrivate() {
      this.viewLock = false;
      dynalt_Material_Private()
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.return.list == null) {
              res.data.return.list = [];
            }
            this.materialPrivate = res.data.return.list;
            this.viewLock = true;
          }
        })
        .catch(this.catchErr);
    },
    dynaltMaterialDelete(url) {
      dynalt_Material_Delete(url)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success("删除成功");
          } else {
            this.$toast.error("删除失败");
          }
          this.dynaltMaterialPrivate();
        })
        .catch(this.catchErr);
    },
    dynaltMaterialUpload(fileType, file) {
      let param = new FormData();
      param.append("file", file);
      param.append("filetype", fileType);
      dynalt_Material_Upload(param)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success("上传成功");
          } else {
            this.$toast.error("上传失败");
          }
          this.dynaltMaterialPrivate();
        })
        .catch(this.catchErr);
    },
    dynaltMaterialCover(id, fileType, file) {
      let param = new FormData();
      param.append("id", id);
      param.append("file", file);
      param.append("filetype", fileType);
      this.viewLock = id;
      dynalt_Material_Cover(param)
        .then(res => {
          if (res.data.code == 200) {
            this.$toast.success("修改成功");
            this.viewLock = true;
          } else {
            this.$toast.error("修改失败");
          }
        })
        .catch(this.catchErr);
    },

    /* - - - - - - - */

    catchErr(err) {
      console.log(err);
      this.$toast.error("网络请求异常");
    },
  },
};
</script>

<style lang="less">
#studio {
  position: relative;
  height: 100%;
  width: 100%;

  background: #ebebeb;
}
.app-head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 100;
  background: #313542;
  padding: 0 20px;
}

.app-logo {
  height: 50px;
  line-height: 50px;

  color: #fff;
  font-size: 22px;
  font-weight: 600;
}

.app-search {
  float: right;
  display: flex;
  height: 30px;

  margin: 9px 0;
  margin-right: 20px;

  border: 1px solid #fff;
  border-radius: 4px;
  background: #fff;
}
.app-search > div {
  background: rgb(141, 141, 141);
  border-radius: 4px;
}
.app-search > div:hover {
  background: rgb(104, 104, 104);
}
.app-search > div:active {
  background: rgb(141, 141, 141);
  user-select: none;
}
.app-search > div img {
  height: 14px;
  width: 14px;

  margin: 6px;
}
.app-search input {
  height: 100%;
  width: 130px;

  border: none;
  padding: 0 10px;
  margin: none;
  outline: none;
}

.app-menu {
  position: absolute;
  z-index: 19970801;
  top: 50px;
  left: 0;
  width: 240px;
  bottom: 0;
  background-color: #304156;
  border-right: 1px solid #ebebeb;
  overflow-x: hidden;
  overflow-y: auto;
}

.app-menu-name {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-weight: 700;
  color: #eee;
  border-bottom: 1px solid #e8ecf0;
  padding-left: 30px;
}
.app-menu-app {
  position: relative;
  display: block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding-left: 30px;
  font-size: 14px;
  overflow: hidden;
  user-select: none;
}
.app-menu-app:hover {
  background: #1a2427;
}
.app-menu-area {
  position: absolute;
  top: 0;
  left: 0;

  height: 100%;
  width: 3px;
  background: #108cee;
}
.app-create {
  float: right;
  height: 30px;
  line-height: 28px;

  margin: 9px 0;
  padding: 0 14px;

  border-radius: 4px;
  border: 1px solid #d7d7d7;

  color: #ffffffb3;
  user-select: none;
}
.app-create:hover {
  color: #fff;
}
.app-create:active {
  color: #1a2427;
}

.app-compose {
  position: absolute;
  top: 100px;
  left: 250px;
  height: calc(100% - 100px);
  width: calc(100% - 250px);

  overflow-y: scroll;

  background: #fff;
}

.app-compose-head {
  display: flex;
  position: absolute;
  top: 50px;
  left: 250px;
  width: calc(100% - 250px);
  height: 50px;

  background: #fff;
  border-bottom: 1px solid #e8ecf0;
}
.app-compose-head .mu-button {
  width: 50px;
  height: 32px;
  margin: 8px 10px 8px 10px;
}
#studio .app-compose-head .mu-button-small {
  height: 32px;
  width: 32px;
}

.layui-input {
  height: 32px;

  border: none;
  padding: 0 10px;
  margin: 8px 0 8px 10px;
  outline: none;

  border: 1px solid #e8ecf0;
  font-size: 12px;
}

.app-compose-item {
  float: left;
  width: 238px;
  height: 298px;

  margin-left: 10px;
  margin-top: 10px;

  border-radius: 1px;
  border: 1px solid #d7d7d7;
}
.app-compose-img {
  position: relative;
  width: 100%;
  height: 160px;
}
.app-compose-img img {
  display: inline-block;
  width: calc(100%);
  height: 100%;
}
.app-compose-img > label {
  position: absolute;
  top: 0;
  right: 0;

  height: 30px;
  width: 30px;

  padding: 5px;
  cursor: pointer;

  background: rgba(0, 0, 0, 0.4);
  border-radius: 0 0 0 4px;
}
.app-compose-img svg {
  width: 100%;
  height: 100%;
}

.app-compose-info {
  height: 58px;
  width: 100%;

  padding-right: 8px;

  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.app-compose-check {
  position: relative;
  float: left;
  width: 40px;
  height: 60px;
}
.app-compose-checkbox {
  width: 16px;
  height: 16px;

  margin: 22px 12px;

  border-radius: 2px;
  border: 1px solid #d2d2d2;
}
.app-compose-checkbox:hover {
  border: 1px solid #a0a0a0;
  cursor: pointer;
}
.app-compose-name {
  position: relative;
  float: right;
  width: 185px;
  height: 30px;

  padding-left: 5px;
  border-bottom: 1px solid #eee;

  font-size: 12px;
  line-height: 30px;
  user-select: none;
  cursor: pointer;
}

.app-compose-id {
  position: relative;
  float: right;
  width: 185px;
  height: 30px;

  padding-left: 5px;

  font-size: 12px;
  line-height: 30px;
  user-select: none;
  cursor: pointer;
}

.app-compose-foot {
  width: 100%;
  height: 76px;

  padding: 10px 0;
}
.app-compose-but {
  position: relative;
  float: left;
  width: 25%;

  margin: 5px 0;
  border-right: 1px solid #d7d7d7;

  line-height: 18px;
  text-align: center;
  font-size: 12px;
  color: #1694f3;

  cursor: pointer;
}
.app-compose-but:hover {
  color: #333;
}

.border-none {
  border: none;
}

.app-material-public {
  position: absolute;
  top: 141px;
  left: 250px;
  height: calc(100% - 50px - 91px);
  width: calc(100% - 250px);

  background: #fff;

  overflow-x: hidden;
  overflow-y: scroll;
}

.app-material-nav {
  position: relative;
  width: calc(100% - 250px);
  top: 50px;
  left: 250px;
  min-height: 50px;
  border-bottom: 1px solid #d7d7d7;
  overflow: hidden;
  padding-top: 10px;
  background: #fff;
}
.app-material-nav .name {
  float: left;
  width: 90px;
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  font-weight: 700;
  color: #666;
  padding-left: 10px;
  overflow: hidden;
}
.app-material-nav .url {
  display: block;
  width: auto;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  border: 1px solid #d7d7d7;
  margin: 0 10px 10px 0;
  padding: 0 20px;
  color: #333;
  font-size: 12px;
  border-radius: 5px;
  background-color: #fff;
  user-select: none;
  cursor: pointer;
}

.material-item {
  position: relative;
  float: left;
  width: 140px;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.material-item .img {
  position: relative;
  width: 140px;
  height: 160px;
  line-height: 160px;
  text-align: center;
  border: 1px solid #d7d7d7;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDkzNzZFN0RDODhFMTFFOEExOUJFNkQ0MTNFM0Q2OTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDkzNzZFN0VDODhFMTFFOEExOUJFNkQ0MTNFM0Q2OTYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEOTM3NkU3QkM4OEUxMUU4QTE5QkU2RDQxM0UzRDY5NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEOTM3NkU3Q0M4OEUxMUU4QTE5QkU2RDQxM0UzRDY5NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PktroGEAAAAoSURBVHjaYvz06RMDDPDy8sLZTAw4AOkSjP///4dzPn/+TAs7AAIMAG56COJosoI3AAAAAElFTkSuQmCC);
  background-repeat: repeat;
  overflow: hidden;
}
.material-item .img img {
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  border: none;
  vertical-align: middle;
}
.material-item .btn {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  padding: 20px 0;
  background-color: #108cee;
  display: none;
  overflow: hidden;
}
.material-item:hover .btn {
  display: flex;
  flex-flow: column;
}

.material-item .btn a,
.material-item .btn > div {
  flex: 1;
  font-size: 14px;
  line-height: 60px;
  color: rgb(197, 197, 197);
  cursor: pointer;
  text-align: center;
}

.material-item .btn a:hover,
.material-item .btn > div:hover {
  color: #fff;
  background-color: #1686db;
}

.app-material-private {
  position: absolute;
  top: 100px;
  left: 250px;
  height: calc(100% - 100px);
  width: calc(100% - 250px);

  padding: 10px;
  background: #fff;

  overflow-x: hidden;
  overflow-y: scroll;
}

.materialUpload {
  background: #2196f3;
  border-radius: 36px;
  font-size: 14px;
  min-width: 88px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  padding: 0 16px;
  color: #fff;
  margin: 9px 0 9px 20px;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
}
.materialUpload:hover {
  background: #3aa6ff;
}
.materialUpload:active {
  background: #3aa6ff;
  box-shadow: 3px 3px 13px rgba(0, 0, 0, 0.4);
}
</style>


